import { BoardState, TargetCategory } from "../contexts/boardContext";

import { TalkCategory } from "./../services/talkServices";

export const findCategory = (
  list: TalkCategory[],
  key: keyof TalkCategory,
  value: string | number,
  depth: number
): TalkCategory[] | undefined => {
  if (depth === 2) {
    const result = list.find(
      (category) => category[key]?.toString() === value.toString()
    );
    return result ? [result] : undefined;
  }
  for (let i = 0; i < list.length; i++) {
    const category = list[i];
    if (category[key]?.toString() === value.toString()) {
      return [category];
    }
    const result = findCategory(
      category.lifeCategoryList ?? [],
      key,
      value,
      depth + 1
    );
    if (result) {
      return [category, ...result];
    }
  }
};

export const findCategoryForContext = (
  list: TalkCategory[],
  key: keyof TalkCategory,
  value: string | number,
  depth: number
): BoardState | undefined => {
  if (depth === 1) {
    const result = list.find(
      (category) => category[key]?.toString() === value.toString()
    );
    return result ? { middleCategory: result } : undefined;
  } else {
    for (let i = 0; i < list.length; i++) {
      const category = list[i];
      if (category[key]?.toString() === value.toString()) {
        if (depth === 0) {
          return {
            largeCategory: category,
            middleCategory: undefined,
          };
        } else {
          return { middleCategory: category };
        }
      }
      const result = findCategoryForContext(
        category.lifeCategoryList ?? [],
        key,
        value,
        depth + 1
      );
      if (result) {
        if (depth === 0) {
          return {
            largeCategory: category,
            middleCategory: undefined,
            ...result,
          };
        } else {
          return {
            middleCategory: category,
            ...result,
          };
        }
      }
    }
  }
};

export const findCategoryByAlias = (
  data: TalkCategory[],
  targetAlias: string
): TargetCategory => {
  const largeCategory = data?.find((category) =>
    category.lifeCategoryList?.some((item) => item.alias === targetAlias)
  );

  let middleCategory = undefined;
  if (largeCategory) {
    middleCategory = largeCategory.lifeCategoryList?.find(
      (category) => category.alias === targetAlias
    );
  }

  return { largeCategory, middleCategory };
};
